import type { ReactNode } from 'react';
import { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { useCalendarContext } from '@/components/calendar/context';
import { getYearButtonRef, scroll } from '@/components/calendar/utils';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';
import Time from '@/utils/time';
import '@/components/calendar/components/month/month-v2.css';
import '@/components/calendar/components/month/month-v1.css';

export default function Month() {
  const { monthNames, startPosition, yearList, date, onCalendarClick } = useCalendarContext();
  const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);
  const [isMonthStep, setIsMonthStep] = useState<boolean>(true);
  const [month, setMonth] = useState<string>('');
  const [year, setYear] = useState<string>('');
  const wrapperRef = useRef<HTMLDivElement>(null);
  const yearRef = useRef<HTMLButtonElement>(null);
  const yearStartRef = useRef<HTMLButtonElement>(null);

  const renderButtons = (items: string[], isMonth: boolean): ReactNode[] =>
    items.map((name) => (
      <button
        key={name}
        type='button'
        ref={getYearButtonRef(isMonth, [name, year, String(startPosition.getFullYear())], [yearRef, yearStartRef])}
        className={clsx('calendar-month__button', {
          'calendar-month__button--selected': name === (isMonth ? month : year),
        })}
        onClick={() => {
          if (isMonth) {
            setMonth(name);
            setIsMonthStep(false);
          } else {
            setYear(name);
            onCalendarClick(Time.date(1, monthNames.indexOf(month), +name));
          }
        }}
      >
        {name}
      </button>
    ));

  useEffect(() => {
    if (!wrapperRef.current || isMonthStep) return;
    if (yearRef.current) {
      scroll(yearRef.current, wrapperRef.current);
    }
    if (!yearRef.current && yearStartRef.current) {
      scroll(yearStartRef.current, wrapperRef.current);
    }
  }, [isMonthStep]);

  useEffect(() => {
    if (date) {
      setMonth(monthNames[date.getMonth()]);
      setYear(String(date.getFullYear()));
    }
  }, [date, monthNames]);

  return (
    <div
      ref={wrapperRef}
      data-css-version={cssVersion}
      className={clsx('calendar-month', {
        'calendar-month--small-list': yearList.length <= 12,
      })}
    >
      {renderButtons(isMonthStep ? monthNames : yearList.map(String), isMonthStep)}
    </div>
  );
}
